module.exports = __webpack_public_path__ + "static/media/gero26.dc7a98f9.JPG";